import db from '@klinx/utils/localstorage';

export default {
  namespaced: true,
  state: {
    dictDetail: db.get('DICTDETAIL') || {},
    roleDetail: db.get('ROLEDETAIL') || {},
    DeviceHub: db.get('DEVICEHUB') || {},
    userAuthority: db.get('USERAUTHORITY') || {},
    envConfig: db.get('ENV_CONFIG') || {}
  },
  mutations: {
    setDictDetail(state, val) {
      db.save('DICTDETAIL', val);
      state.dictDetail = val;
    },
    setEnvConfig(state, val) {
      db.save('ENV_CONFIG', val);
      state.envConfig = val;
    },
    clearDict(state, val) {
      db.remove(val);
      state.dictDetail = '';
    },
    setRoleDetail(state, val) {
      db.save('ROLEDETAIL', val);
      state.roleDetail = val;
    },
    clearRole(state, val) {
      db.remove(val);
      state.roleDetail = '';
    },
    setDeviceHub(state, val) {
      db.save('DEVICEHUB', val);
      state.DeviceHub = val;
    },
    clearDeviceHub(state, val) {
      db.remove(val);
      state.DeviceHub = '';
    },
    setUserAuthority(state, val) {
      db.save('USERAUTHORITY', val);
      state.userAuthority = val;
    },
    clearUserAuthority(state, val) {
      db.remove(val);
      state.userAuthority = '';
    }
  }
};
